const SCROLL_GUARD_KEY = 'product-section-deep-link-done';

/**
 * @typedef {{
 *   scrollId?: string,
 *   scrollSelector?: string,
 *   tabId: string,
 *   afterScroll?: () => void
 * }} CustomSectionConfig
 */

/** @type {Record<string, CustomSectionConfig>} */
const CUSTOM_SECTIONS = {
  reviews: {
    scrollSelector: '.aura-testimonials',
    tabId: 'reviews',
  },
  full_ingredients: {
    scrollSelector: '.aura-testimonials',
    tabId: 'reviews',
    afterScroll: openFullIngredientsList,
  },
};

/**
 * Opens the "+ FULL INGREDIENTS LIST" drawer in the actives section.
 * @returns {boolean}
 */
function openFullIngredientsList() {
  const activesSection = document.getElementById('actives');
  const scope = activesSection ?? document;
  const components = scope.querySelectorAll('dialog-component.popup-link');

  for (const component of components) {
    const button = component.querySelector('.popup-link__button');
    if (button?.dataset.auraPopup !== 'full_ingredients') continue;

    // @ts-ignore
    if (typeof component.showDialog === 'function') {
      // @ts-ignore
      component.showDialog();
    } else {
      // @ts-ignore
      button?.click();
    }
    return true;
  }

  return false;
}

/**
 * @returns {number}
 */
function getScrollOffset() {
  const headerGroupHeight = parseFloat(
    getComputedStyle(document.body).getPropertyValue('--header-group-height')
  );
  const headerHeight = Number.isFinite(headerGroupHeight) && headerGroupHeight > 0 ? headerGroupHeight : 0;

  const tabsSection = document.querySelector('.tabs-section')?.closest('.shopify-section');
  const tabsHeight = tabsSection instanceof HTMLElement ? tabsSection.offsetHeight : 0;

  if (headerHeight > 0 || tabsHeight > 0) {
    return headerHeight + tabsHeight + 10;
  }

  const header = document.querySelector('header');
  return (header?.offsetHeight ?? 0) + tabsHeight + 10;
}

/**
 * @param {string} id
 */
function activateProductTab(id) {
  const activeBtn = document.querySelector(`.tab-btn[data-tab="${CSS.escape(id)}"]`);
  if (!(activeBtn instanceof HTMLButtonElement)) return;

  document.querySelectorAll('.tab-btn').forEach((btn) => btn.classList.remove('active'));
  activeBtn.classList.add('active');
}

/**
 * @param {HTMLElement} target
 */
function scrollToSectionTarget(target) {
  const offset = getScrollOffset();
  const y = target.getBoundingClientRect().top + window.scrollY - offset;
  window.scrollTo({ top: y, behavior: 'instant' });
}

/**
 * @returns {boolean}
 */
function runProductSectionDeepLink() {
  const url = new URL(window.location.href);
  const sectionParam = url.searchParams.get('section')?.trim();
  if (!sectionParam) return false;

  const guardKey = `${SCROLL_GUARD_KEY}:${url.pathname}${url.search}`;
  if (sessionStorage.getItem(guardKey) === '1') return false;

  const custom = CUSTOM_SECTIONS[sectionParam];
  const scrollId = custom?.scrollId ?? sectionParam;
  const tabId = custom?.tabId ?? sectionParam;
  const target = custom?.scrollSelector
    ? document.querySelector(custom.scrollSelector)
    : document.getElementById(scrollId);
  if (!target && !custom) return false;

  sessionStorage.setItem(guardKey, '1');

  if (target) {
    activateProductTab(tabId);
    // @ts-ignore
    scrollToSectionTarget(target);
  } else if (custom) {
    activateProductTab(tabId);
  }

  if (custom?.afterScroll) {
    requestAnimationFrame(() => {
      // @ts-ignore
      requestAnimationFrame(() => custom.afterScroll());
    });
  }

  if (target && window.history?.replaceState) {
    const next = new URL(window.location.href);
    next.hash = custom?.scrollSelector ? sectionParam : scrollId;
    window.history.replaceState(null, '', next.toString());
  }

  return true;
}

function scheduleDeepLink() {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => runProductSectionDeepLink(), { once: true });
    return;
  }
  runProductSectionDeepLink();
}

scheduleDeepLink();

window.addEventListener('pagereveal', (event) => {
  const run = () => runProductSectionDeepLink();
  const viewTransition = /** @type {PageRevealEvent} */ (event).viewTransition;

  if (viewTransition?.finished) {
    viewTransition.finished.then(run);
  } else {
    requestAnimationFrame(run);
  }
});